import { fetchFromApi } from './apiUtils';

const basePath = '/v1/userdetails';

const getUserDetails = () => fetchFromApi(basePath);

export default {
  getUserDetails,
};
